import {
  LocalActivity,
  People,
  Storefront,
  WorkspacePremium,
} from "@mui/icons-material";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

export default function Stats() {
  const theme = useTheme();
  const achievements = [
    { value: "۵۰k+", label: "کاربر فعال", icon: <People /> },
    { value: "۱۰۰+", label: "باشگاه همکار", icon: <Storefront /> },
    { value: "۳۰۰+", label: "مربی حرفه‌ای", icon: <WorkspacePremium /> },
    { value: "۱۰k+", label: "جلسه ورزشی", icon: <LocalActivity /> },
  ];
  const items = achievements.map((item, index) => (
    <Grid size={{ xs: 6, md: 3 }} key={index}>
      <Box
        sx={{
          textAlign: "center",
          p: 2,
          position: "relative",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "translateY(-4px)",
            "& .stat-icon": {
              transform: "scale(1.1)",
            },
          },
          "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            top: "20%",
            height: "60%",
            width: "1px",
            bgcolor: "divider",
            display:
              index === achievements.length - 1
                ? "none"
                : { xs: "none", md: "block" },
          },
        }}
      >
        <Box
          className="stat-icon"
          sx={{
            display: "inline-flex",
            p: 1.5,
            borderRadius: "50%",
            bgcolor: `${theme.palette.primary.main}10`,
            color: theme.palette.primary.main,
            mb: 1,
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {item.icon}
        </Box>
        <Typography
          sx={{
            fontSize: "1.8rem",
            fontWeight: 800,
            color: theme.palette.primary.main,
          }}
        >
          {item.value}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.85rem",
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          {item.label}
        </Typography>
      </Box>
    </Grid>
  ));
  return (
    <Grid container sx={{ mb: 8 }}>
      {items}
    </Grid>
  );
}
